import { Component, OnInit } from '@angular/core';
import { ROUTES } from 'src/app/constants/Routes';


@Component({
  selector: 'app-vc-score',
  templateUrl: './vc-score.component.html',
  styleUrls: ['./vc-score.component.scss'],
  standalone: false
})
export class VCScoreComponent implements OnInit {
  Routes = ROUTES;
  activeSection = 'overview';
  workflowImage = 'assets/images/websitev2/workflow-diagrams/varroc-score.png';

  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'events', label: 'Event Detection', icon: 'bx-radar' },
    { id: 'usecases', label: 'Use Cases', icon: 'bx-briefcase' },
    { id: 'scoring', label: 'Scoring Engine', icon: 'bx-stats' },
    { id: 'workflow', label: 'Workflow', icon: 'bx-git-branch' },
  ];

  events = [
    { label: 'Harsh Braking', icon: 'bx-down-arrow-circle', desc: 'Detects sudden deceleration events beyond safe thresholds.' },
    { label: 'Rapid Acceleration', icon: 'bx-up-arrow-circle', desc: 'Flags aggressive throttle inputs and rapid speed increases.' },
    { label: 'Sharp Turns', icon: 'bx-rotate-right', desc: 'Identifies aggressive cornering and lane-change manoeuvres.' },
    { label: 'Over-Speeding', icon: 'bx-tachometer', desc: 'Tracks sustained high-speed driving and speed zone violations.' },
    { label: 'Prolonged Idling', icon: 'bx-time-five', desc: 'Monitors extended idle periods for efficiency and emissions.' },
    { label: 'Night-Time Driving', icon: 'bx-moon', desc: 'Detects high-risk driving hours and zone-based movement.' },
    { label: 'Distance & Trips', icon: 'bx-map-alt', desc: 'Tracks total distance, trip count, and driving patterns.' },
    { label: 'Vehicle Health Anomalies', icon: 'bx-wrench', desc: 'Flags usage anomalies and health-correlated driving behaviour.' },
  ];

  useCases = [
    {
      title: 'Safe Driving Evaluation',
      icon: 'bx-check-shield',
      desc: 'Score individual drivers and fleet operators on real-world behaviour for safety programs and compliance tracking.',
    },
    {
      title: 'Usage-Based Insurance (UBI)',
      icon: 'bx-file',
      desc: 'Enable PHYD and PHYU insurance products with verified telematics-driven behaviour profiles for accurate premium calculation.',
    },
    {
      title: 'Driver Coaching',
      icon: 'bx-user-voice',
      desc: 'Provide actionable feedback and improvement pathways to help drivers develop safer habits over time.',
    },
    {
      title: 'Fleet Performance Benchmarking',
      icon: 'bx-bar-chart-alt-2',
      desc: 'Compare driver and vehicle performance across fleet segments with leaderboard-style ranking and trend analytics.',
    },
  ];

  scoringPoints = [
    'Event-based scoring with configurable weights per event type.',
    'Multi-dimensional score computation across safety, efficiency, and compliance.',
    'Temporal scoring windows: per-trip, daily, weekly, and monthly.',
    'Percentile ranking against peer cohorts for relative performance.',
    'Score history and trend tracking per driver and vehicle.',
    'OEM-configurable thresholds aligned to product requirements.',
  ];

  ngOnInit() {}


  scrollTo(sectionId: string) {
    const el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.activeSection = sectionId;
  }

  private setupIntersectionObserver() {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) this.activeSection = entry.target.id;
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    this.sections.forEach(s => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });
  }
}
